import React, { useState } from 'react';
import { User, Mail, Phone, Calendar, Save, X, Edit2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Card } from '../ui/Card';
import { mockExtendedUser } from '../../utils/mockAccountData';
import { useNotifications } from '../../context/NotificationsContext';
export function PersonalInfoSection() {
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    addNotification
  } = useNotifications();
  const [formData, setFormData] = useState({
    name: mockExtendedUser.name,
    email: mockExtendedUser.email,
    phone: mockExtendedUser.phone || '',
    dateOfBirth: mockExtendedUser.dateOfBirth || ''
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsEditing(false);
      addNotification('success', 'Información personal actualizada correctamente');
    }, 1000);
  };
  return <div className="space-y-6" data-id="element-320">
      <div className="flex items-center justify-between" data-id="element-321">
        <div data-id="element-322">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-323">
            Información Personal
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-324">
            Gestiona tu información de contacto y detalles personales.
          </p>
        </div>
        {!isEditing && <Button variant="outline" onClick={() => setIsEditing(true)} className="hidden sm:flex" data-id="element-325">
            <Edit2 className="w-4 h-4 mr-2" data-id="element-326" />
            Editar Perfil
          </Button>}
      </div>

      <Card className="overflow-hidden" data-id="element-327">
        {isEditing ? <form onSubmit={handleSubmit} className="p-6 md:p-8" data-id="element-328">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-329">
              <Input label="Nombre Completo" value={formData.name} onChange={e => setFormData({
            ...formData,
            name: e.target.value
          })} required data-id="element-330" />
              <Input label="Correo Electrónico" type="email" value={formData.email} onChange={e => setFormData({
            ...formData,
            email: e.target.value
          })} required data-id="element-331" />
              <Input label="Teléfono" type="tel" value={formData.phone} onChange={e => setFormData({
            ...formData,
            phone: e.target.value
          })} placeholder="+34 600 000 000" data-id="element-332" />
              <Input label="Fecha de Nacimiento" type="date" value={formData.dateOfBirth} onChange={e => setFormData({
            ...formData,
            dateOfBirth: e.target.value
          })} data-id="element-333" />
            </div>

            <div className="flex items-center justify-end gap-3 pt-6 border-t border-gray-100" data-id="element-334">
              <Button type="button" variant="ghost" onClick={() => setIsEditing(false)} disabled={isLoading} data-id="element-335">
                Cancelar
              </Button>
              <Button type="submit" disabled={isLoading} data-id="element-336">
                {isLoading ? <span className="flex items-center" data-id="element-337">
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2" data-id="element-338" />
                    Guardando...
                  </span> : <span className="flex items-center" data-id="element-339">
                    <Save className="w-4 h-4 mr-2" data-id="element-340" />
                    Guardar Cambios
                  </span>}
              </Button>
            </div>
          </form> : <div className="p-6 md:p-8" data-id="element-341">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-342">
              <div className="flex items-start" data-id="element-343">
                <div className="w-10 h-10 bg-emerald-50 rounded-lg flex items-center justify-center flex-shrink-0 text-emerald-600" data-id="element-344">
                  <User className="w-5 h-5" data-id="element-345" />
                </div>
                <div className="ml-4" data-id="element-346">
                  <p className="text-sm font-medium text-gray-500" data-id="element-347">
                    Nombre Completo
                  </p>
                  <p className="text-base font-semibold text-gray-900 mt-1" data-id="element-348">
                    {formData.name}
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-349">
                <div className="w-10 h-10 bg-emerald-50 rounded-lg flex items-center justify-center flex-shrink-0 text-emerald-600" data-id="element-350">
                  <Mail className="w-5 h-5" data-id="element-351" />
                </div>
                <div className="ml-4" data-id="element-352">
                  <p className="text-sm font-medium text-gray-500" data-id="element-353">
                    Correo Electrónico
                  </p>
                  <p className="text-base font-semibold text-gray-900 mt-1" data-id="element-354">
                    {formData.email}
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-355">
                <div className="w-10 h-10 bg-emerald-50 rounded-lg flex items-center justify-center flex-shrink-0 text-emerald-600" data-id="element-356">
                  <Phone className="w-5 h-5" data-id="element-357" />
                </div>
                <div className="ml-4" data-id="element-358">
                  <p className="text-sm font-medium text-gray-500" data-id="element-359">Teléfono</p>
                  <p className="text-base font-semibold text-gray-900 mt-1" data-id="element-360">
                    {formData.phone || 'No especificado'}
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-361">
                <div className="w-10 h-10 bg-emerald-50 rounded-lg flex items-center justify-center flex-shrink-0 text-emerald-600" data-id="element-362">
                  <Calendar className="w-5 h-5" data-id="element-363" />
                </div>
                <div className="ml-4" data-id="element-364">
                  <p className="text-sm font-medium text-gray-500" data-id="element-365">
                    Fecha de Nacimiento
                  </p>
                  <p className="text-base font-semibold text-gray-900 mt-1" data-id="element-366">
                    {formData.dateOfBirth ? new Date(formData.dateOfBirth).toLocaleDateString('es-ES', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                }) : 'No especificada'}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-100 sm:hidden" data-id="element-367">
              <Button variant="outline" fullWidth onClick={() => setIsEditing(true)} data-id="element-368">
                <Edit2 className="w-4 h-4 mr-2" data-id="element-369" />
                Editar Perfil
              </Button>
            </div>
          </div>}
      </Card>
    </div>;
}